import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { d as L, j as b } from "../../vendor-Dd6qj6gJ.js";
import { useState as l } from "react";
import { copyToClipboard as T } from "../../utils/copyToClipboard/index.js";
import "../../theme/spacing.js";
import { AriaLive as P } from "../AriaLive/index.js";
import { getButtonStyles as x } from "../BaseButton/index.js";
import { BaseIcon as p } from "../BaseIcon/index.js";
import { TooltipTrigger as U, Tooltip as w } from "../Tooltip/index.js";
import '../../assets/index24.css';const G = "_copyButton_1i70l_1", H = "_copyIcon_1i70l_13", F = "_pendingIcon_1i70l_14", O = "_checkmarkIcon_1i70l_15", j = "_pending_1i70l_14", A = "_success_1i70l_69", $ = "_copyComplete_1i70l_1", t = {
  copyButton: G,
  copyIcon: H,
  pendingIcon: F,
  checkmarkIcon: O,
  pending: j,
  success: A,
  copyComplete: $
}, o = {
  IDLE: 0,
  PENDING: 1,
  SUCCESS: 2
}, M = {
  [o.IDLE]: "",
  [o.PENDING]: "Copying...",
  [o.SUCCESS]: "Copied"
}, Z = ({
  onCopy: d,
  onError: m,
  content: y,
  size: s = "md",
  isDisabled: u,
  cache: C,
  m: I,
  mt: S,
  mr: E,
  mb: f,
  ml: _,
  "aria-label": g = "Copy to clipboard"
}) => {
  const [h, N] = l(!1), [n, r] = l(o.IDLE), D = L(
    x({
      m: I,
      mb: f,
      ml: _,
      mr: E,
      mt: S,
      size: s,
      variant: "ghost"
    }),
    t.copyButton,
    {
      [t.pending]: n === o.PENDING,
      [t.success]: n === o.SUCCESS
    }
  ), k = n === o.SUCCESS || h && n === o.IDLE;
  async function v() {
    if (n === o.IDLE) {
      r(o.PENDING);
      try {
        if (!await T(y, { cache: C }))
          throw new DOMException("copyToClipboard did not complete successfully");
        r(o.SUCCESS), d?.();
      } catch (c) {
        m?.(c instanceof Error ? c : new Error(String(c))), r(o.IDLE);
      }
    }
  }
  function B(c) {
    c.animationName === t.copyComplete && r(o.IDLE);
  }
  function i(c) {
    N(c.type === "hoverstart" || c.type === "focus");
  }
  return /* @__PURE__ */ a(U, { isOpen: k, children: [
    /* @__PURE__ */ a(
      b,
      {
        "data-component": "CopyButton",
        "aria-label": g,
        onHoverStart: i,
        onHoverEnd: i,
        onFocus: i,
        onBlur: i,
        className: D,
        isDisabled: u,
        onAnimationEnd: B,
        isPending: n === o.PENDING,
        onPress: () => v(),
        children: [
          /* @__PURE__ */ e(p, { size: s, color: "green", className: t.checkmarkIcon, icon: "checkmark" }),
          /* @__PURE__ */ e(p, { size: s, className: t.copyIcon, icon: "copy" }),
          /* @__PURE__ */ e(p, { size: s, className: t.pendingIcon, icon: "loading" }),
          /* @__PURE__ */ e(P, { children: M[n] })
        ]
      }
    ),
    /* @__PURE__ */ e(w, { children: n === o.SUCCESS ? "Copied" : "Copy to clipboard" })
  ] });
};
export {
  Z as CopyButton
};
